import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { DirectivesModule } from "src/app/shared/directives.module";
import { SharedModule } from "src/app/shared/shared.module";
import { AllocationDetailComponent } from "./allocation-detail/allocation-detail.component";
import { AllocationListComponent } from "./allocation-list/allocation-list.component";
import { ViewAllocationsComponent } from "./view-allocations/view-allocations.component";
import { ViewLogListComponent } from "./view-log/view-log-list/view-log-list.component";
import { ViewLogSearchComponent } from "./view-log/view-log-search/view-log-search.component";
import { ViewTodayOrdersComponent } from "./view-today-orders/view-today-orders.component";
import { AllocationProgressActionsComponent } from "./allocation-progress-actions/allocation-progress-actions.component";
import { AllocationsTableComponent } from "./allocations-table/allocations-table.component";
import { AllocationOrdersTableComponent } from "./allocation-orders-table/allocation-orders-table.component";

@NgModule({
    declarations: [
        AllocationListComponent, 
        ViewTodayOrdersComponent, 
        ViewAllocationsComponent, 
        ViewLogListComponent, 
        ViewLogSearchComponent, 
        AllocationDetailComponent,
        AllocationProgressActionsComponent,
        AllocationsTableComponent,
        AllocationOrdersTableComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        DirectivesModule
    ]
})
export class AllocationModule { }
